// Standalone strain-reviews widget — static configuration.
// Resolves the API base URL from the loading <script src> so customer
// sites just embed the script tag with no per-site config required.

const _scriptSrc = (typeof document !== 'undefined'
                    && document.currentScript
                    && document.currentScript.src) || '';
const _autoApi = _scriptSrc ? new URL(_scriptSrc).origin : '';

export const API_URL =
    (typeof window !== 'undefined'
     && window.VB_STRAIN_REVIEWS_CONFIG
     && window.VB_STRAIN_REVIEWS_CONFIG.API_URL) ||
    _autoApi ||
    (typeof window !== 'undefined' ? window.location.origin : '');

export const MODAL_ID = 'vbsr-modal';
export const STYLES_ID = 'vbsr-styles';
export const TRIGGER_SELECTOR = '[data-strain-name]';

export const TABS = [
    { id: 'reviews',  label: 'Reviews' },
    { id: 'lineage',  label: 'Lineage' },
    { id: 'terpenes', label: 'Terpenes' },
    { id: 'effects',  label: 'Effects & uses' },
];
